
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '出張費用はかかりますか？',
      answer: '出張費用は一切かかりません。査定料、キャンセル料も無料です。お気軽にご依頼ください。',
    },
    {
      question: '査定にはどのくらい時間がかかりますか？',
      answer: '品物の数や状態にもよりますが、通常30分〜1時間程度です。丁寧に査定させていただきます。',
    },
    {
      question: '登録証がない刀でも買取できますか？',
      answer: '登録証のない日本刀は法律上買取できません。登録証の取得方法についてはご相談ください。',
    },
    {
      question: '遺品整理での買取も可能ですか？',
      answer: 'はい、可能です。故人が大切にされていた品物を丁寧に査定いたします。相続に関するご相談も承ります。',
    },
    {
      question: 'どのような状態でも買取できますか？',
      answer: '錆びや傷がある品物でも買取可能です。まずは現状のままお見せください。修復の必要はありません。',
    },
    {
      question: 'キャンセルはできますか？',
      answer: 'もちろん可能です。査定額にご納得いただけない場合は、遠慮なくお断りください。キャンセル料は一切かかりません。',
    },
    {
      question: '複数の品物をまとめて査定してもらえますか？',
      answer: 'はい、何点でも査定いたします。まとめてお売りいただくと、査定額アップの可能性もございます。',
    },
  ];

  return (
    <section id="faq" className="py-20 lg:py-28 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-12">
        <header className="text-center mb-16">
          <div className="inline-block bg-samurai-red/10 px-6 py-2 rounded-full mb-6">
            <p className="text-samurai-red font-bold text-base lg:text-lg whitespace-nowrap">FAQ</p>
          </div>
          <h2 className="text-4xl lg:text-5xl font-black text-samurai-dark mb-6 font-serif">
            よくあるご質問
          </h2>
          <p className="text-xl lg:text-2xl text-samurai-gray max-w-3xl mx-auto leading-relaxed">
            お客様からよくいただくご質問をまとめました
          </p>
        </header>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <article
              key={index}
              className="bg-white rounded-xl shadow-lg border-2 border-gray-100 overflow-hidden transition-all duration-300 hover:border-samurai-gold"
            >
              <h4>
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full px-6 lg:px-8 py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
                  aria-expanded={openIndex === index}
                >
                  <div className="flex items-start gap-4 flex-1">
                    <div className="w-10 h-10 bg-samurai-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <span className="text-samurai-red font-black text-lg">Q</span>
                    </div>
                    <span className="text-xl lg:text-2xl font-bold text-samurai-dark leading-relaxed">
                      {faq.question}
                    </span>
                  </div>
                  <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                    <i
                      className={`text-2xl text-samurai-red transition-transform duration-300 ${
                        openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                      }`}
                    ></i>
                  </div>
                </button>
              </h4>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 lg:px-8 pb-6 pt-2">
                  <div className="flex items-start gap-4 bg-gray-50 rounded-lg p-6">
                    <div className="w-10 h-10 bg-samurai-gold/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <span className="text-samurai-gold font-black text-lg">A</span>
                    </div>
                    <p className="text-lg lg:text-xl text-samurai-gray leading-relaxed flex-1">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>

        <aside className="mt-16 text-center bg-white rounded-2xl p-8 lg:p-10 shadow-xl border-2 border-gray-100">
          <h3 className="text-2xl lg:text-3xl font-black text-samurai-dark mb-4 font-serif whitespace-nowrap">
            その他のご質問はお気軽に
          </h3>
          <p className="text-lg lg:text-xl text-samurai-gray mb-8 leading-relaxed">
            ご不明な点がございましたら、お電話またはLINEでお問い合わせください
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://lin.ee/Bi3KvRO"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-green-500 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-green-600 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-line-fill text-2xl"></i>
              LINEで質問
            </a>
            <a
              href="tel:070-8453-9292"
              className="inline-flex items-center gap-3 bg-samurai-red text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-samurai-red/90 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill text-2xl"></i>
              電話で質問
            </a>
          </div>
        </aside>
      </div>
    </section>
  );
}
